const TokenKey = 'token'

export function getToken() {
  // return Cookies.get(TokenKey)
	return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
	return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
	// return localStorage.removeItem(TokenKey)
	return localStorage.clear()
	// return (function(){
	// 	localStorage.removeItem(TokenKey)
	// 	localStorage.removeItem('areasList')
	// })()
}
export function getGrant(getdata) {
	return Cookies.get(getdata)
}
export function setGrant(toGrant, setdata) {
	return Cookies.set(toGrant, setdata)
}
export function removeGrant(removedata) {
	return Cookies.remove(removedata)
}

export function getSession(getdata) {
	return window.sessionStorage.getItem(getdata)
}
export function setSession(toGrant, setdata) {
	return window.sessionStorage.setItem(toGrant, setdata)
}
export function removeSession(removedata) {
	return window.sessionStorage.removeItem(removedata)
}

export function getlocalStorage(getdata) {
	return window.localStorage.getItem(getdata)
}
export function setlocalStorage(toGrant, setdata) {
	return window.localStorage.setItem(toGrant, setdata)
}
export function removelocalStorage(removedata) {
	return window.localStorage.removeItem(removedata)
}